import { createAction } from "redux-actions";
import { GET_CHECKBOOK_EMITED } from "../constants";
import { serverGetCheckbook } from "./../services/checkbooks";
import { urlCheckbooks } from "./../services/urls";



export const getCheckbook = createAction(GET_CHECKBOOK_EMITED, (field, charge) => 
    serverGetCheckbook(urlCheckbooks, field, charge)())